import _get from 'lodash/get'

const config = {
  // Auth Providers
  environment: process.env.REACT_APP_ENV || 'local',
  ptForgotPasswordLink: process.env.REACT_APP_PT_FORGOT_PASSWORD_LINK || '',
  auth: {
    default: process.env.REACT_APP_AUTH_PROVIDER || 'demo',
    providers: {
      rest: {
        url: process.env.REACT_APP_API,
      },
    },
  },
  mst: {
    rest: {
      // url: process.env.REACT_APP_API_MST,
      url: process.env.REACT_APP_API_MST
        ? process.env.REACT_APP_API_MST
        : process.env.REACT_APP_API.replace('/backoffice', ''),
    },
  },
  googleMap: {
    apiKey: process.env.REACT_APP_GOOGLE_MAP_APIKEY,
  },
  // Data Providers
  data: {
    default: process.env.REACT_APP_DATA_PROVIDER || 'demo',
    providers: {
      demo: {
        host: 'https://jsonplaceholder.typicode.com',
      },
    },
  },
  // Assets base urls
  assets: {
    baseUrl: {
      image: process.env.REACT_APP_IMG_BASE_URL,
    },
  },
  langSupports: ['th' /* 'en' */],
  resources: {
    keys: {
      admins: 'admin_management',
      roles: 'role_management',
      emailconfig: 'setting_email_config_management',
      services: 'service_management',
      branch_config: 'setting_branch_config_management',
      'booking-view': 'booking_book_view_management',
      booking: 'booking_book_management',
      'temporary-request': 'booking_book_temporary_request_management',
    },
  },
  pages: {
    keys: {
      profile: 'profile',
      'not-found': 'not-found',
    },
  },
}

export default (key, defaultValue = undefined): string => {
  return _get(config, key, defaultValue)
}
